import React from "react";
import Heading from "../common/ui/Heading";
import { STEPS_LIST } from "../../utils/other-component";

const ChooseMakeWay = () => {
  return (
    <div className="px-4 py-10">
      <div className="max-w-[1140px] mx-auto">
        {/* Heading */}
        <div className="flex justify-center mb-12 sm:mb-16">
          <Heading
            children="Why Choose Makeway India and Jeena Sikho?"
            className="text-center max-w-3xl mx-auto text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900"
          />
        </div>

        {/* Steps Wrapper */}
        <div className="relative">
          {/* Dotted line - Hidden on mobile, visible on md and above */}
          <div className="hidden md:block absolute top-12 left-1/2 transform -translate-x-1/2 w-[78%] h-0.5 border-t-2 border-dashed border-gray-300 z-0"></div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 lg:gap-16 relative z-10">
            {STEPS_LIST.map((step, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center px-4 transition-transform duration-300 hover:scale-105"
              >
                {/* Step Circle */}
                <div className="bg-[#328255] text-white rounded-full w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center shadow-lg">
                  <div>
                    <p className="text-sm sm:text-2xl leading-[130%] font-bold ">
                      {step.step}
                    </p>
                    <p className="text-xs uppercase tracking-wide">Step</p>
                  </div>
                </div>

                {/* Step Content */}
                <h3 className="mt-6 text-lg sm:text-xl lg:text-2xl font-semibold text-[#001A3D] leading-[130%]">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm sm  sm:text-base text-[#686868] text-center font-normal max-w-xs">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseMakeWay;
